module.exports = __webpack_public_path__ + "static/media/kg.087037f2.svg";